/**
 * alertActions.js
 * Talkroute
 *
 * Created by Vel Genov on 12/8/18
 * Copyright (c) 2018 Talkroute. All right reserved.
 */

import alertConstants from "../constants/alertConstants";

const alertActions = {
  success,
  error,
  clear,
};

/**
 * A success alert message
 * @param {String} message
 */
function success(message: string) {
  return { type: alertConstants.SUCCESS, message };
}

/**
 * An error alert message
 * @param {String} message
 */
function error(message: string) {
  return { type: alertConstants.ERROR, message };
}

/**
 * An alert message sent to clear existing alert messages
 * @param {String} message
 */
function clear() {
  return { type: alertConstants.CLEAR };
}

export default alertActions;
